import script from "./UserRow.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRow.vue?vue&type=script&setup=true&lang=js"

import "./UserRow.vue?vue&type=style&index=0&id=27eaab36&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27eaab36"]])

export default __exports__